import { Promotion, VolumePrice, PromotionFilterChangedPayload } from '../../models';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AttributeOption } from '~shared/models';
import { FILTER_ATTRIBUTE_KEYS } from '~app/modules/filters/constants';
import { TooltipPositions } from '~shared/modules/tooltip/models/tooltip-positions.model';
import { BlackDeal } from '~app/modules/filters/models/black-deal.model';
import { blackDealFilterChangedPayload } from '~app/modules/filters/models/black-deal-filter-changed-payload.model';
import { BlackDealsFeatureFlagService } from '~shared/services/black-deals-feature-flag.service';

@Component({
  selector: 'app-search-promotion-list',
  templateUrl: './promotion-list.component.html',
  styleUrls: ['./promotion-list.component.scss'],
})
export class PromotionListComponent implements OnChanges, OnDestroy {
  @Input() blackDeal: BlackDeal;
  @Input() promotion: Promotion;
  @Input() volumePrices: VolumePrice;
  @Input() rebuyGuarantee: AttributeOption;
  @Input() queryParams: { [key: string]: any };
  @Input() isMobileOrTablet: boolean;
  @Input() isDesktop: boolean;
  @Output() blackDealFilterChanged = new EventEmitter<blackDealFilterChangedPayload>();
  @Output() promotionChanged = new EventEmitter<PromotionFilterChangedPayload>();
  @Output() volumePriceChanged = new EventEmitter<PromotionFilterChangedPayload>();
  @Output() rebuyGuaranteeChanged = new EventEmitter<AttributeOption>();
  promotionForm: FormGroup;
  tooltipPosition = TooltipPositions.center;
  bulletBackgroundColor = '#E5EAF1';
  blackDealFilterValueSubscription: Subscription = null;
  promotionValueSubscription: Subscription = null;
  volumePriceValueSubscription: Subscription = null;
  rebuyGuaranteeValueSubscription: Subscription = null;

  selectPromotion = {
    blackDeal: false,
    promotion: false,
    volumePrices: false,
    rebuyGuarantee: false,
  };
  isBlackDealsEnabled = this.blackDealsFeatureFlagService.isBlackDealsEnabled();

  constructor(private formBuilder: FormBuilder, private blackDealsFeatureFlagService: BlackDealsFeatureFlagService) {
    this.promotionForm = this.formBuilder.group({ ...this.selectPromotion });
  }
  ngOnChanges(): void {
    const filterOptions = this.queryParams?.filter?.options;
    const blackDeal: string | {} = this.queryParams?.filter?.blackFriday || {};
    const promotion: string | {} = this.queryParams?.filter?.promotion || {};
    const volumePrices: string | {} = this.queryParams?.filter?.volumePrices || {};
    const rebuyGuaranteee: boolean =
      filterOptions && filterOptions[FILTER_ATTRIBUTE_KEYS.CHARACTERISTICS]
        ? filterOptions[FILTER_ATTRIBUTE_KEYS.CHARACTERISTICS]?.includes(FILTER_ATTRIBUTE_KEYS.REBUY_GUARANTEE_OPTION)
        : false;

    this.selectPromotion.blackDeal = Object.keys(blackDeal).length > 0;
    this.selectPromotion.promotion = Object.keys(promotion).length > 0;
    this.selectPromotion.volumePrices = Object.keys(volumePrices).length > 0;
    this.selectPromotion.rebuyGuarantee = rebuyGuaranteee;

    this.promotionForm = this.formBuilder.group({ ...this.selectPromotion });
    this.volumePriceValueSubscription = this.promotionForm.controls['volumePrices'].valueChanges.subscribe(
      (checked: boolean) => {
        this.volumePriceChanged.emit({
          volumePrices: checked ? checked : {},
          promotion: !!this.promotionForm.controls['promotion'].value ? true : {},
        });
      }
    );

    this.promotionValueSubscription = this.promotionForm.controls['promotion'].valueChanges.subscribe(
      (checked: boolean) => {
        this.promotionChanged.emit({
          promotion: checked ? checked : {},
          volumePrices: !!this.promotionForm.controls['volumePrices'].value ? true : {},
        });
      }
    );

    const rebuyGuaranteeControl: AbstractControl = this.promotionForm.controls['rebuyGuarantee'];

    if (rebuyGuaranteeControl) {
      this.rebuyGuaranteeValueSubscription = rebuyGuaranteeControl.valueChanges.subscribe((checked: boolean): void => {
        this.rebuyGuaranteeChanged.emit(checked ? this.rebuyGuarantee : null);
      });
    }

    const blackDealFilterControl = this.promotionForm.controls['blackDeal'];

    if (blackDealFilterControl) {
      this.blackDealFilterValueSubscription = blackDealFilterControl.valueChanges.subscribe(
        (checked: boolean): void => {
          this.blackDealFilterChanged.emit({ blackFriday: checked ? checked : {} });
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.blackDealFilterValueSubscription.unsubscribe();
    this.promotionValueSubscription.unsubscribe();
    this.volumePriceValueSubscription.unsubscribe();
    this.rebuyGuaranteeValueSubscription.unsubscribe();
  }
}
